export default __webpack_public_path__ + "static/media/menstrual-cycle@2x.c92ac3ae.png";